export const CREATE_PARK = 'CREATE_PARK';
export const EDIT_PARKING = 'EDIT_PARKING';
export const SHOW_PARKING_SPACE_NAME = 'SHOW_PARKING_SPACE_NAME';
export const PARKING_SPACE_NAME_SUCCESS = 'PARKING_SPACE_NAME_SUCCESS';
export const PARKING_SPACE_NAME_ERROR = 'PARKING_SPACE_NAME_ERROR';

export const REMOVE_TICKET = 'REMOVE_TICKET';
export const RESTORE_TICKET = 'RESTORE_TICKET';

